import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Html } from '@react-three/drei';
import Model from './Model';

export default function App() {
   return (
      <Canvas
         camera={{ position: [2, 0, 12.25], fov: 10 }}
         className="canvas"
         style={{
            width: '100vw',
            height: '100vh',
         }}
      >
         <ambientLight intensity={1.25} />
         <ambientLight intensity={0.1} />
         <directionalLight intensity={0.4} />
         <Suspense fallback={<Html as="div"><h1 className='loader'>Loading ...</h1></Html>}>
            <Model position={[0.025, -0.9, 0]} /> 
         </Suspense>
         <OrbitControls />
      </Canvas>
   );
}
